var slotRootStyle = 'fx_b722dd09_1ucncm00';

export { slotRootStyle };
//# sourceMappingURL=layout.vanilla.mjs.map
